import {Typography } from '@material-ui/core'
import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'
import CustomizedDialogs from '../dialog'
import GetAppIcon from '@material-ui/icons/GetApp';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from "@material-ui/core/styles";
import CliniqueService from '../../services/CliniqueService'
import { toast } from "react-toastify";
import FournisseurForm from '../FournisseurForm'



const Fournisseur = () => {
    const useStyles = makeStyles({
        root: {
          maxWidth: 345,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent:'center',
        }
      });
  const classes = useStyles();
  const [fournisseurs,setFournisseurs] = useState([])

  console.log("fournisseurs ===== ",fournisseurs)

  useEffect(() => {
    const fetchData = async () => {
       await CliniqueService.getFournisseurs()
          .then((response) => {
            setFournisseurs(response.data)
          })
          .catch(e => {
            console.log(e);
         });
        }

        
     fetchData();
  }, [])
   

      const refreshFournisseurs = async () =>{
       await  CliniqueService.getFournisseurs()
           .then((response) => {
            setFournisseurs(response.data)
            })
            .catch(e => {
              console.log(e);
            });
      }

    
    

  const columns = [
    { title: "ID", field: "idFournisseur",align: "center", filterPlaceholder: "filter" },
    { title: "NOM FOURNISSEUR", field: "nomFournisseur",align: "center", filterPlaceholder: "filter" },
    { title: "PHONE 1", field: "phone1"},
     { title: "PHONE 2", field: "phone2",filterPlaceholder: "filter"},
     { title: "EMAIL", field: "email",filterPlaceholder:"filter"},
     { title: "ADRESSE", field: "adresse",filterPlaceholder:"filter"},
     { title: "CREATEUR", field: "speudo",filterPlaceholder:"filter",editable: 'never' },
   ]

    return (
        <div className="App" style={{width:"100%", display:'flow',justifyContent:'center',alignItems:'center',top:0,bottom:0,margin:'auto'}}>
            <Typography variant="title" className={classes.title}>
            Liste des fournisseurs
            </Typography>
            <div style={{display:"flex",justifyContent:'flex-start',margin:15}}>
        <div>
         <CustomizedDialogs title="Nouveau fournisseur" icon="business" boutonTitle="Ajouter un fournisseur" refresh={()=>refreshFournisseurs()}>
                   <FournisseurForm />
       </CustomizedDialogs>
      </div>
        </div>
            <MaterialTable columns={columns} data={fournisseurs}
      onRowClick={(evt,rowData)=>{

      }}
        editable={{
          onRowAdd: (newRow) => new Promise((resolve, reject) => {
              CliniqueService.createFournisseur(newRow)
                  .then((response) => {
                    toast.success("Votre commande modifiee avec success...", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshFournisseurs()

                  })
                  .catch((error) => {
                    console.log(error);
                    toast.error(error.response?.data, {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                  });
            refreshFournisseurs()
            setTimeout(() => resolve(), 500)
          }),
          onRowUpdate: (newRow, oldRow) => new Promise((resolve, reject) => {
            
              CliniqueService.updateFournisseur(newRow,oldRow.idFournisseur)
                  .then((response) => {
                    toast.success("Fournisseur modifie avec success...", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshFournisseurs()

                  })
                  .catch((error) => {
                    console.log(error);
                    toast.error(error.response?.data, {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                  });
            setTimeout(() => resolve(), 500)
          }),
          onRowDelete: (selectedRow) => new Promise((resolve, reject) => {
            CliniqueService.deleteFournisseur(selectedRow.idFournisseur)
                  .then((response) => {
                    toast.success("Fournisseur supprime avec success...", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshFournisseurs()

                  })
                  .catch((error) => {
                    console.log(error);
                    toast.error(error.response?.data, {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                  });
            setTimeout(() => resolve(), 1000)
          })
        }}
        actions={[
          {
            icon: () => <GetAppIcon />,
            tooltip: "details",
            onClick: (event, rowData) => {
              console.log(rowData)
            },
            
          }
        ]}
        onSelectionChange={(selectedRows) => console.log(selectedRows)}
        options={{
          sorting: true, search: true,
          searchFieldAlignment: "right", searchAutoFocus: true, searchFieldVariant: "standard",
          filtering: true, paging: true, pageSizeOptions: [2, 5, 10, 20, 25, 50, 100], pageSize: 5,
          paginationType: "stepped", showFirstLastPageButtons: false, paginationPosition: "both", exportButton: true,
          exportAllData: true, exportFileName: "Fournisseurs", addRowPosition: "first", actionsColumnIndex: -1, selection: true,
          showSelectAllCheckbox: false, showTextRowsSelected: false, selectionProps: rowData => ({
            //disabled: rowData.age == null,  
            color:"primary"
          }),
           columnsButton: true,
          rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
          headerStyle: { background: "#226D68",color:"#fff"},
          
        }}
        title="Liste des fournisseurs "
        icons={{ Add: () => <AddIcon /> }} />
          </div>
    )
}

export default Fournisseur
